import { render, staticRenderFns } from "./PremiumYield.vue?vue&type=template&id=aa454ce2&scoped=true"
import script from "./PremiumYield.vue?vue&type=script&lang=js"
export * from "./PremiumYield.vue?vue&type=script&lang=js"
import style0 from "./PremiumYield.vue?vue&type=style&index=0&id=aa454ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa454ce2",
  null
  
)

export default component.exports